@let isLoading = loadingService.isLoading$(this) | async;

@if (dataSource) {
  <icz-documents-table
    tableId="ownership-transfer-object-selection"
    tableTitle="Objekty pro zařazení do sdílené složky"
    class="grow"
    [dataSource]="dataSource"
    [searchTerm]="modalData.searchTerm ?? ''"
    [viewType]="DocumentView.SHARED_FOLDER_FILLER_SELECTION_FILTERS"
    [allowOpenQuickPreview]="false"
    [hideTableToolbar]="false"
    [hideTableToolbarButtons]="true"
    (searchTermChange)="searchTermChanged($event)"
    (activeFiltersChange)="activeFiltersChanged($event)"
    (initialized)="docTableInitialized($event)"
  >
    <icz-label noDataLabel label="Žádné objekty"></icz-label>
  </icz-documents-table>
}

<icz-form-buttons>
  <icz-button leftButtons
              [disabled]="areNoCriteriaChosen || isLoading"
              [iczTooltip]="areNoCriteriaChosen ? 'Je nutné stanovit alespoň jedno kritérium pro výběr objektů.' : null"
              (onAction)="submit()"
              primary label="Uložit kritéria výběru objektů"
  ></icz-button>
  <icz-button rightButtons
              [disabled]="isLoading"
              (onAction)="cancel()" label="Storno"
  ></icz-button>
</icz-form-buttons>
